<section class="story-container">
  <!-- Fundraiser Ended label -->
  <app-end-fundraiser-banner
    *ngIf="fundraiser"
    [isFundraiserEnded]="isFundraiserEnded"
    [isSuccessfullyFunded]="isSuccessfullyFunded"
    [fundraiser]="fundraiser"
    [campaignUrl]="campaignUrl"
    [basicInfo]="basicInfo"
    [sharedCounts]="sharedCounts">
  </app-end-fundraiser-banner>

  <div>
    <div class="container" *ngIf="!isFundraiserEnded && hide_el">
      <ng-template [ngTemplateOutlet]="urgentBanner"></ng-template>
    </div>
    <app-banner
      [fundraiser]="fundraiser"
      [theaterImg]="theaterImage"
      (watchVideo)="scrollToVideo($event)"
      [isFundraiserEnded]="isFundraiserEnded">
    </app-banner>
  </div>

  <div *ngIf="!fundraiser" class="container">
    <app-placeholder-loader type="story"></app-placeholder-loader>
  </div>

  <div id="story-container" class="container">
    <!-- Benficiary adn support card -->
    <div *ngIf="isMobile && hide_el" class="row">
      <div class="col-sm-12 col-xs-12 support-card">
        <div class="bene-card">
          <app-benficiary-card
            *ngIf="fundraiser?.basicinfo"
            [fundraiser]="fundraiser"
            [sharyCard]="sharyCard"
            [basicInfo]="basicInfo"
            [beneficiary]="beneficiary"
            [donationCard]="donationCard"
            [isDonated]="isDonated"
            [currency]="currency"
            [isFundraiserEnded]="isFundraiserEnded"
            (watchVideo)="scrollToVideo($event)">
          </app-benficiary-card>
        </div>
      </div>
    </div>
    <div class="row content-area">
      <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 default-pad left-content-area">
        <!-- Story Tabs -->
        <app-story-tabs
          [fundraiser]="fundraiser"
          [updates]="updates"
          [isDonated]="isDonated"
          [sharedCounts]="sharedCounts"
          [isFundraiserEnded]="isFundraiserEnded"
          [campaingUrl]="campaignUrl"
          [basicinfo]="basicInfo"
          [currency]="currency"
          (tabIndex)="getTabIndex($event)"
          [hide_el]="hide_el">
        </app-story-tabs>

        <!-- Hospital/Doctor Contact -->
        <div *ngIf="fundraiser && fundraiser?.hospital" class="section-container">
          <div class="section-title"><span class="title-text">{{'Stories.contact.contact' | translatePipe | async}}</span></div>
          <div class="section-content">
            <app-hospital-doctor-contact [fundraiser]="fundraiser"></app-hospital-doctor-contact>
          </div>
        </div>

        <!-- Documents -->
        <div inViewport (inViewportAction)="inViewPortListner($event, 'docs')" *ngIf="checkLength(fundraiser?.viewmedicalbill) && tabIndex !== 1 && hide_el" class="section-container">
          <div class="section-title"><span class="title-text">{{'Stories.donations.medDocs' | translatePipe | async}}</span></div>
          <div *ngIf="inViewPort.docs" class="section-content">
            <app-story-docs [gallery]="fundraiser?.viewmedicalbill" [isMobile]="isMobile"></app-story-docs>
          </div>
        </div>

        <div *ngIf="!isFundraiserEnded && currencyInfo?.currency=='INR' && (fundraiser?.banktransfer?.info_3 || fundraiser?.settings?.show_qr)" class="section-container">
          <div class="section-title"><span class="title-text">{{ 'Stories.bankTransfer.donationMethods' | translatePipe | async}}</span></div>
          <div class="section-content">
            <app-donation-methods [donateBtnLabel]="qParams?.hide_el?.match('2|3') ? 'Contribute Now' : 'Donate Now'" [fundraiser]="fundraiser" [bank]="fundraiser?.banktransfer" origin="s" [recommendTag]="false" [tagLabel]="''" [theme]="''">
            </app-donation-methods>
          </div>
        </div>

        <!-- Video appealing -->
        <div *ngIf="fundraiser?.video_appeal" class="section-container">
          <div class="section-title"><span class="title-text">
            Watch this 10-second video appeal from {{beneficiary?.full_name}}’s family:
          </span></div>
          <div *ngIf="videoSrc" class="section-content">
            <!-- Youtube embed -->
            <iframe #youtubeEmbed class="video-container" type="text/html" [src]="videoSrc | safeUrl"></iframe>
          </div>
          {{videoSrc}}
        </div>

        <!-- Supporter's Comments -->
        <div *ngIf="hide_el" class="section-container">
          <div *ngIf="comments?.total > 0" class="section-title">
            <span class="title-text">{{'Stories.referAFriend.supportersComments' | translatePipe | async}} <span *ngIf="checkLength(comments?.data)">({{comments?.total}})</span></span>
          </div>
          <!-- Comments card -->
          <div inViewport (inViewportAction)="inViewPortListner($event, 'comments')" class="section-content">
            <app-module-loader [load]="inViewPort.comments && comments?.data?.length>0" moduleId="comment-card" selector="app-comment-card" [inputs]="{comments: comments, origin: 'stories', postCommentLabel: ('Stories.referAFriend.writeSomethingToCheer' | translatePipe | async)+fundraiser?.campaigner?.fname, campaignId: fundraiser?.id, customTag: fundraiser?.custom_tag}"></app-module-loader>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 default-pad right-content-area">
        <div *ngIf="!isMobile" class="support-card">
          <!-- Donor card -->
          <app-support-card class="donor-card" *ngIf="donationCard && donationCard.length" [donations]="donationCard"
            cardType="donor" [campaingUrl]="campaignUrl" [fundraiser]="fundraiser">
          </app-support-card>
          <!--Sharee card -->
          <app-support-card class="donation-card" [donations]="sharyCard"
              *ngIf="sharyCard && sharyCard.length" cardType="sharee">
          </app-support-card>
        </div>
        <div *ngIf="!isFundraiserEnded" [hidden]="isMobile" class="payment-card" [ngStyle]="{'top': vars?.fundraiser?.tip_model?'-165px': '0px'}">
          <!--Beneficiary card-->
          <div class="bene-card">
            <app-benficiary-card
              *ngIf="fundraiser?.basicinfo"
              [fundraiser]="fundraiser"
              [basicInfo]="basicInfo"
              [beneficiary]="beneficiary"
              [isFundraiserEnded]="isFundraiserEnded"
              [donationCard]="donationCard"
              [isDonated]="!isDonated"
              (watchVideo)="scrollToVideo($event)"
              [type]="'v1'">
            </app-benficiary-card>
          </div>
          <div *ngIf="!isMobile" class="formtitle">Choose the amount you wish to Donate</div>
          <app-main-payment *ngIf="fundraiser && (!isMobile || qParams?.st=='f')" [internal]="true" [fundraiser]="fundraiser" origin="s" [recommendTag]="false" [tagLabel]="''" [theme]="''" [showBeneficiary]="true" [type]="paymentDialogType" [onpage]="!isMobile" [captchaType]="isMobile ? 'dialog' : 'onpage'"></app-main-payment>
        </div>
      </div>
      <div class="some-space"></div>
    </div>
  </div>
</section>
<app-social-share-btn [ngClass]="hide_el ? 'd-sm-none' : ''" *ngIf="fundraiser" [fundraiser]="fundraiser" [basicInfo]="basicInfo" [isFundraiserEnded]="isFundraiserEnded"></app-social-share-btn>
<!-- Story Footer -->
<app-social-number *ngIf="hide_el" [fundraiser]="fundraiser"></app-social-number>
<app-copyright-footer />
<section class="container-fluid">
  <div *ngIf="fundraiser && !isFundraiserEnded && isMobile" id="dock-section" >
    <div id="urgentSlide" (scroll)="onWindowScroll()" class="urgent-slide">
      <span class="txt">{{getFirstName(beneficiary?.info_1)}} needs funds before {{fundraiser?.end_date | dayjs:'format':'Do MMM YY'}}</span>
      <span *ngIf="!fundraiser?.settings?.hidedaysleft" class="days-left">
        <i class="icon-stopwatch"></i>
        {{+(fundraiser?.end_date | dayjs:'diffInDays') > 0 ? +(fundraiser?.end_date | dayjs:'diffInDays') : 0}} {{+(fundraiser?.end_date | dayjs:'diffInDays') <= 1 ? 'Day' : 'Days'}} left
      </span>
    </div>
    <div class="fixed-button">
      <app-donate-now [showLabel]="true" [label]="('Stories.donations.makeDonation' | translatePipe |async)" [fundraiser]="fundraiser" [position]="9" [openDonate]="isMobile" [recommendTag]="false" [tagLabel]="''" [theme]="''"></app-donate-now>
    </div>
  </div>
</section>


<ng-template #urgentBanner>
  <div class="urgent-banner-container">
    <div class="urgent-banner">
      <i class="material-icons">warning</i>
      <span class="urgent-txt">{{ 'Stories.urgentNeedFunds' | translatePipe | async}}</span>
    </div>
  </div>
</ng-template>